import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  router = inject(Router);
  private msalService = inject(MsalService);
  private http = inject(HttpClient);

  public isLogedIn: boolean = false;

  isLoggedIn$ = new BehaviorSubject<boolean>(false);
  userInfo$ = new BehaviorSubject<any>(null);

  userLogin() {
    const account = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0]
      ?? null;
    if (!account) {
      this.userInfo$.next(null);
      this.isLoggedIn$.next(false);
      return;
    }
    this.msalService.instance.setActiveAccount(account);
    const claims: any = account.idTokenClaims ?? {};
    const groups: string[] = (claims.groups as string[]) || (claims.roles as string[]) || [];

    // let role = '';
    // if (environment.handlerGroup.some((g: string) => groups.includes(g))) {
    //   role = 'handler';
    // } else if (environment.managerGroup.some((g: string) => groups.includes(g))) {
    //   role = 'manager';
    // }

    const isSuperUser =
      environment.superUserGroup?.some((g: string) => groups.includes(g)) ?? false;
    const isUser =
      environment.userGroup?.some((g: string) => groups.includes(g)) ?? false;
    const role = isSuperUser ? 'super_user' : isUser ? 'user' : '';

    this.userInfo$.next({
      name: account.name ?? '',
      email: account.username ?? '',
      role,
      groups,
      isSuperUser,
      isUser,
      photoUrl: '',
    });
    this.isLoggedIn$.next(true);
    this.fetchUserPhoto();
  }

  logout() {
    this.isLoggedIn$.next(false);
    this.userInfo$.next(null);
    this.msalService.logoutRedirect();
  }

  private fetchUserPhoto() {
    this.http
      .get('https://graph.microsoft.com/v1.0/me/photo/$value', { responseType: 'blob' })
      .subscribe({
        next: (blob) => {
          const photoUrl = URL.createObjectURL(blob);
          const current = this.userInfo$.value;
          if (current) {
            this.userInfo$.next({ ...current, photoUrl });
          }
        },
        error: () => {
        },
      });
  }
}
